import './func/change_sec3';
import './func/select_service';
import './func/select_service_reward';//추후에 클래스나 클로저로 위의 함수와 합칠 예정
import {addRow} from './func/get_coupons';
import SecVote from "./func/change_sec3";

const layer_list = [
    {
        el: '#layer-reward',
        buttons: '.p-btn--reward'
    },
    {
        el: '#layer-mycoupons'
    },
];
let make_layer = layer_list.map(ele=>{
    return ele['buttons'] && promokit.layer(ele);
});
let couponlayer = promokit.layer(layer_list[1]);

/* 레이어 - data 갯수 카운트하여 row 추가 */
$('.p-btn--mycoupons').on('click',function () {
    couponlayer.open();
});

/* 이미지 프리로딩 div 삭제. */
document.getElementById("preload_div").remove();

/* 투표창 처리를 위한 secVote 인스턴스. */
window.secVote = new SecVote();

let page = promokit.page({
    el:'#container',
    type:'basic',
    game: 'plaync',
    cnb:true,
    topButton:true,
    footer:{
        theme:'white'
    },
    headerButton:{
        home:false,
        event:false,
        update:false,
        sns:true,
        theme:'black'
    },
    caution:{
        template:
        `<ol>
            <li>본 이벤트는 
            <a href="https://lineage.plaync.com/board/event/event_agreement">리니지</a>, 
            <a href="https://lineage2.plaync.com/board/event/rule">리니지2</a>, 
            <a href="https://aion.plaync.com/event/rule">아이온</a>, 
            <a href="https://bns.plaync.com/board/event/rule">블레이드 & 소울</a>, 
            <a href="https://bufftoon.plaync.com/policy/event">버프툰</a> 각 이벤트 규약을 따르며<br>
            <a href="https://lineagem.plaync.com/board/rules/view?articleId=1320058&viewMode=list&size=20">리니지 M</a>, 
            <a href="https://lineage2m.plaync.com/board/rules/view?articleId=102&viewMode=list&size=20">리니지 2M</a>, 
            <a href="https://bns2.plaync.com/board/rules/view?articleId=6021e517fa04f10001585d6c">블레이드 & 소울 2</a>, 
            <a href="https://tricksterm.plaync.com/board/rules/view?articleId=5f8438021f27df00015ffa54&isNotice=false">트릭스터 M</a>, 
            <a href="https://h2.plaync.com/board/rules/view?articleId=13&viewMode=card">프로야구 H2</a>, 
            <a href="https://h3.plaync.com/board/rules/view?articleId=60125a1a0bb8f100019e5228&viewMode=list&size=20 &_ga=2.136061937.1369285624.1631670611-1848402535.1580878174">프로야구 H3</a>
             는 모바일 게임서비스 이벤트 규약을 따릅니다.</li>
            <li>이벤트 선물은 동일 금액의 다른 보상으로 변경될 수 있습니다.</li>
            <li>PLAYNC 서비스 별 보상 외 선물은 당첨자 발표 후 개인정보를 접수해 주신 분들에 한하여 일괄 발송됩니다. </li>
            <li>부정한 방법으로 참여한 경우 당첨 경품 지급이 불가하며, 예고없이 당첨이 취소될 수 있습니다.</li>
            <li>경품 지급 일정은 주최측의 사정에 의해 변동될 수 있습니다.</li>
            <li>전화번호 계정으로 변경 참여 시 기존 이벤트 참여 내역은 이전되지 않을 수 있습니다.</li>
        </ol>`
    }
});


// WEBPACK FOOTER //
// ./src/js/index.js